<template>
  <span>{{ formatNumber(price) }}</span>
</template>

<script>
export default {
  name: 'AppCoursePrice',
  props: ['price'],
  methods: {
    formatNumber(num) {
      let number = parseInt(num)
      return number ? number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'): '0'
    }
  },
  created() {
  }
}
</script>

<style scoped lang="scss">

</style>
